import React, { useEffect } from 'react';
import { Patient } from '../store/types/patient';
import { AbhaIconLinkedLess, AbhaIconLinkedMore } from '../components/common/Icons';
import { EKA_EVENT, dispatch } from '../bridge/events/dispatch';

import { isAbhaV2 } from './ToggleAbhaFlowVersion';
import { Events, ON_ABHA_LINK_POP_UP_CLOSE } from '../bridge/events/types';
import { useSelector } from 'react-redux';
import { GlobalStateV1 } from '../store/reducers';
import { getGenieSetting } from '../store/selectors/session';
import { getMyClinics } from '../store/idbHandler';
import AntButton from '../components/prescriptionPad/rightPanel/workspace/padV2/AntButton';
import { AntTooltip } from '../components/common/AntTooltip';

const AbhaNotLinkedPopover: React.FC<{
    cId: string;
    patient: Patient | undefined;
    handleOpenChange: (newOpen: boolean) => void;
    open: boolean;
    openLinkAbhaModel: () => void;
    className?: string;
    requestAbha: () => void;
    atLeastOneAbhaLinked?: boolean;
}> = ({ cId, patient, openLinkAbhaModel, className }) => {
    // const isAbdmEnabled = useSelector((state: GlobalStateV1) =>
    //     getGenieSetting(state, 'abdm'),
    // ) as boolean;

    // const handleEventDispatch = (e: Event) => {
    //     const { detail } = e as CustomEvent<Events>;
    //     switch (detail.type) {
    //         case ON_ABHA_LINK_POP_UP_CLOSE:
    //             dispatch({
    //                 type: 'DESTROY_CONTAINER',
    //                 containerId: ABHA_LINK_IN_DOCTOOL_CONTAINER,
    //             });
    //             window.location.reload();
    //             break;
    //     }
    // };

    useEffect(() => {
        // if (isAbhaV2() && isAbdmEnabled) {
        //     renderStuff(true, { cId, link: 'true' }, {});
        //     window.addEventListener(EKA_EVENT, handleEventDispatch);
        //     return () => {
        //         window.removeEventListener(EKA_EVENT, handleEventDispatch);
        //     };
        // }
    }, []);

    const currentAbha = patient?.abha || patient?.abhaV2?.[0];
    const moreThan5Records = currentAbha?.records && currentAbha?.records >= 5;

    return currentAbha ? (
        <AntTooltip content={currentAbha.id}>
            <div
                className={`${moreThan5Records ? 'abha-linked-more' : 'abha-linked-less'} ${
                    className ?? 'flex p-6 justify-between items-center gap-2 rounded-8 w-127'
                }`}
            >
                <div className="flex gap-2 items-center">
                    {moreThan5Records ? AbhaIconLinkedMore : AbhaIconLinkedLess}
                    <p className="font-700 text-13 break-words">
                        {currentAbha?.records ? currentAbha?.records : 0} Records
                    </p>
                </div>
                <span className="p-4"></span>
            </div>
        </AntTooltip>
    ) : (
        <div
            className={`${
                className ??
                'flex p-6 cursor-pointer justify-between items-center gap-2 rounded-8 abha-not-linked w-127'
            }`}
            onClick={() => openLinkAbhaModel()}
        >
            <div className="flex gap-2 items-center">
                <svg
                    width="15"
                    height="14"
                    viewBox="0 0 15 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="mx-4"
                >
                    <path
                        d="M7.5 13.625C5.16406 13.625 3.03125 12.4062 1.86328 10.375C0.695312 8.36914 0.695312 5.90625 1.86328 3.875C3.03125 1.86914 5.16406 0.625 7.5 0.625C9.81055 0.625 11.9434 1.86914 13.1113 3.875C14.2793 5.90625 14.2793 8.36914 13.1113 10.375C11.9434 12.4062 9.81055 13.625 7.5 13.625ZM7.5 3.875C7.14453 3.875 6.89062 4.1543 6.89062 4.48438V7.32812C6.89062 7.68359 7.14453 7.9375 7.5 7.9375C7.83008 7.9375 8.10938 7.68359 8.10938 7.32812V4.48438C8.10938 4.1543 7.83008 3.875 7.5 3.875ZM6.6875 9.5625C6.6875 10.0195 7.04297 10.375 7.5 10.375C7.93164 10.375 8.3125 10.0195 8.3125 9.5625C8.3125 9.13086 7.93164 8.75 7.5 8.75C7.04297 8.75 6.6875 9.13086 6.6875 9.5625Z"
                        fill="#D74B41"
                    />
                </svg>
                <p className="font-700 text-13">No ABHA</p>
            </div>
            <span className="p-4">
                <svg
                    width="6"
                    height="9"
                    viewBox="0 0 6 9"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M4.76562 5.03906L1.76562 8.03906C1.55469 8.25 1.22656 8.32031 0.945312 8.20312C0.664062 8.08594 0.476562 7.80469 0.476562 7.5V1.5C0.476562 1.19531 0.664062 0.9375 0.945312 0.820312C1.22656 0.703125 1.55469 0.773438 1.76562 0.984375L4.76562 3.98438C5.07031 4.26562 5.07031 4.75781 4.76562 5.03906Z"
                        fill="#1A1A1A"
                    />
                </svg>
            </span>
        </div>
    );
};

export default AbhaNotLinkedPopover;
